import { Permission } from './permission';

export class DropdownItem {
  public text: string;
  public value: string;
  public permission?: Permission;

  constructor(_text: string, _value: string, _permission?: Permission) {
    this.text = _text;
    this.value = _value;
    this.permission = _permission;
  }
}


// WEBPACK FOOTER //
// ./src/types/dropdown-item.ts